import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { variables } from '../Variables/Variable';
import { Modal } from "react-bootstrap";
import { useContext } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";

const PortfolioDetails = () => {
    const { setDynamicMeta } = useContext(MetadataContext);
    const [albumItems, setAlbumItems] = useState([]);
    const [show, setShow] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const [albumName, setAlbumName] = useState("");
    const ID = useParams();

    useEffect(() => {
        if (!albumItems.length) return;

        const firstItem = albumItems[0];

        setDynamicMeta({
            Title:
                firstItem.MetaTitle ||
                `Home Depot | ${firstItem.AlbumName}`,

            Description:
                firstItem.MetaDescription ||
                `Explore ${firstItem.AlbumName} projects by Home Depot. Premium tiles, ceramics, and sanitary ware installations.`,

            Keywords:
                firstItem.MetaKeyword ||
                `${firstItem.AlbumName}, tiles, ceramics, sanitary ware, home depot portfolio`,

            Url: window.location.href,

            Type: "website",

            Image: firstItem.ImageUrl
                ? variables.PHOTO_URL + firstItem.ImageUrl.replace(/ /g, "%20")
                : "",

            TwitterCard: "summary_large_image",
        });

        // 🔥 cleanup when leaving page
        return () => setDynamicMeta(null);
    }, [albumItems]);

    const getItemsByAlbumId = () => {
        fetch(variables.API_URL + "AlbumItem/GetAlbumItems/" + ID.AlbumId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setAlbumName(Result[0]?.AlbumName);
                setAlbumItems(Result);
            });
    }

    useEffect(() => {
        getItemsByAlbumId();
    }, [])
    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header page-header--services-single-one page-header--protfolio-single">
                <div className="page-header__bg" style={{ backgroundImage: `url(${variables.PHOTO_URL + albumItems[0]?.ImageUrl})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper text-center">
                                <div className="page-header__content">
                                    <h2>{albumName}</h2>
                                    <div className="number">
                                        <a href="tel:01558517">+ 961 1 558517/+961 8 554546</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}

            <section className="projects-one projects-one--protfolio">
                <div className="auto-container">
                    <div className="row">
                        {
                            albumItems.map((album, index) => {
                                return (
                                    <div key={index} className="col-xl-3 col-lg-6 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                        <div className="projects-one__single">
                                            <div className="projects-one__single-img">
                                                <a onClick={() => { setShow(true); setImageUrl(album.ImageUrl) }}>
                                                    <img id='test' src={variables.PHOTO_URL + album.ImageUrl} alt="" style={{ width: '400px', height: '300px' }} />
                                                </a>
                                            </div>

                                            <div className="projects-one__single-content">
                                                <h2><a>{album.AlbumName}</a></h2>
                                                {/* <h2><a href="Portfolio-Details">{album.AlbumName}</a></h2> */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </section>
            <Modal
                show={show}
                fullscreen={false}
                onHide={() => setShow(false)}
            >
                <Modal.Header closeButton>

                </Modal.Header>
                <Modal.Body >
                    <img src={variables.PHOTO_URL + imageUrl} style={{ width: "100%", height: "100%" }} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PortfolioDetails